import React, { useState, useEffect } from 'react';
import { Layout, Menu } from 'antd';
import Logo from "../../Asset/Images/Logo.png";
import './style.css';

const { Header } = Layout;

const Headers = ({ refs }) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scrollToRef = (ref) => {
    if (ref?.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
      setMenuVisible(false);
    }
  };

  const items = [
    { key: 'home', label: 'Home', onClick: () => scrollToRef(refs?.homeRef) },
    { key: 'about', label: 'About', onClick: () => scrollToRef(refs?.aboutRef) },
    { key: 'team', label: 'Team', onClick: () => scrollToRef(refs?.teamRef) },
    { key: 'documents', label: 'Disclosures', onClick: () => scrollToRef(refs?.documentsRef) },
    { key: 'contact', label: 'Contact Us', onClick: () => scrollToRef(refs?.contactRef) },
  ];

  return (
    <Header className="custom-header">
      <div className="header-inner">
        <div className="logo-container">
          <img src={Logo} alt="Logo" className="logo" />
        </div>
        {isMobile ? (
          <div className="menu-toggle" onClick={() => setMenuVisible(!menuVisible)}>
            ☰
          </div>
        ) : (
          <Menu
            theme="light"
            mode="horizontal"
            defaultSelectedKeys={['home']}
            items={items}
            className="desktop-menu"
          />
        )}
      </div>
      {isMobile && (
        <div className={`menu-wrapper ${menuVisible ? 'active' : ''}`}>
          <Menu
            theme="light"
            mode="vertical"
            defaultSelectedKeys={['home']}
            items={items}
            className="custom-menu"
          />
        </div>
      )}
    </Header>
  );
};

export default Headers;
